import React, {useState} from "react";

export default function Modal(){
    const [uName, setUname] = useState()
    const [uPhone, setUphone] = useState()
    const userName = (e) => {
    setUname(e.target.value)
    }
    const userPhone = (e) => {
    setUphone(e.target.value)
}
    const call = () => {
        if (uName && uPhone)
        {
            alert('Спасибо за обращение ' + uName + "! Мы перезвоним вам по номеру " + uPhone)
            document.getElementById("modal").style.display = "none"
            document.getElementById("modal").style.bottom = "0"
            document.getElementById("modal").style.right = "0"
        }
        else return
    }
     const modalClose = () => {
         document.getElementById("modal").style.display = "none"
         document.getElementById("modal").style.bottom = "0"
        document.getElementById("modal").style.right = "0"
    }
    return (
        <>
            <div id="modal" className="text-right">
                <img id="modalx" src="../images/modalx.png" onClick={modalClose} />
                    <p id='modaltitle' className="text-left">Узнать, как гарантированно освободиться от всех задолженностей через банкротство в Вашей ситуации</p>
            <p id="modaltext" className="text-left">Наши специалисты готовы дать Вам любую, даже самую глубокую, юридическую консультацию совершенно бесплатно.</p>
           
            <form id="modalform" className="form-group required control-label" onSubmit={call}>
                    <div className="container-fluid">
                    <div className="row">
                    <div className="col-sm">
                        <input type="text" placeholder="Имя*" onChange={userName} id="modalname" className="form-control" required></input>
                    </div>
                    <div class="col-sm">
                        <input type="number" placeholder="Номер телефона*" onChange={userPhone} id="modalphone" className="form-control" required></input>
                    </div>
                    </div>
                    <div className="row">
                        <div class="col-sm text-left padl">
                            <input type="submit" value="Жду звонка!" id="modalsbm" />
                        </div>
                        <div class="col-sm text-left padl">
                            <div id="modalexplain" className="text-left margl">Нажимая на кнопку "Оставить заявку", я даю свое согласие на обработку персональных данных и принимаю условия соглашения</div>
                        </div>
                    </div>
                </div>
            </form>
            </div>
            </>
    )
}